import React, { useMemo } from 'react';

import { defaultTheme } from '@mutiny-pkg/champaign-schemas/src/schemas/themeProperties/defaultTheme';
import { ThemeProperties } from '@mutiny-pkg/champaign-schemas/src/schemas/themeProperties/types';

import { ThemeContext } from '@mutiny-pkg/bin-ui/src/rigidMicrosites/theme/ThemeContext';
import { useFonts } from '@mutiny-pkg/bin-ui/src/rigidMicrosites/theme/useFonts';

type ThemeProviderProps = {
  children: React.ReactNode;
  theme?: ThemeProperties;
  dynamicFonts?: boolean;
};

export function ThemeProvider({ children, theme = defaultTheme, dynamicFonts = false }: ThemeProviderProps) {
  const themeContext = useMemo(() => ({ theme }), [theme]);
  useFonts(theme.fontFaces, dynamicFonts);

  return <ThemeContext.Provider value={themeContext}>{children}</ThemeContext.Provider>;
}
